<template>
  <div class="plan-container plan-container__reports">
    <p class="title">Custom Graphs</p>
    <div class="graph-container">
      <div class="graph-report">
        <button class="button" @click="exportToCSV">Download CSV</button>
        <p class="subtitle">Primary area of need</p>
        <!-- Quarterly or Annually -->
        <div class="options-select">
          <p>View Primary area of need:</p>
          <div class="select">
            <select v-model="needsKey">
              <option value="all">All</option>
              <option v-for="need in needs" :key="need" :value="need">
                {{ need }}
              </option>
            </select>
          </div>
        </div>
        <div id="graph-need" class="graphing" ref="graph-need"></div>
        <div class="graph-options-container">
          <div class="graph-options">
            <div class="option-radio">
              <input type="radio" value="all" v-model="keystageKey" />
              All
            </div>
            <div
              class="option-radio"
              v-for="keyStage in keyStages"
              :key="keyStage"
            >
              <input type="radio" :value="keyStage" v-model="keystageKey" />
              {{ keyStage }}
            </div>
          </div>
          <div class="graph-options">
            <div class="option-radio">
              <input type="radio" value="all" v-model="panPeriod" />
              All
            </div>
            <div
              class="option-radio"
              v-for="option in periods"
              :key="option.value"
            >
              <input type="radio" :value="option.value" v-model="panPeriod" />
              {{ option.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="graph-report">
        <button class="button" @click="SectionDataToExportToCSV">
          Download CSV
        </button>
        <p class="subtitle">Theme of QHA</p>
        <!-- Quarterly or Annually -->
        <div class="options-select">
          <p>View Theme:</p>
          <div class="select">
            <select v-model="sectionKey">
              <option value="a">1. Timeliness & Details</option>
              <option value="b">2. SEN Health Needs</option>
              <option value="c">3. Non SEN Health Needs</option>
              <option value="d">4. Outcomes</option>
              <option value="e">5. Provision</option>
              <option value="f">6. Co-production</option>
            </select>
          </div>
        </div>
        <div id="graph-section" class="graphing" ref="graph-section"></div>
        <div class="graph-options-container">
          <div class="graph-options">
            <div class="option-radio">
              <input type="radio" value="all" v-model="sectionKeystageKey" />
              All
            </div>
            <div
              class="option-radio"
              v-for="keyStage in keyStages"
              :key="keyStage"
            >
              <input
                type="radio"
                :value="keyStage"
                v-model="sectionKeystageKey"
              />
              {{ keyStage }}
            </div>
          </div>
          <div class="graph-options">
            <div class="option-radio">
              <input type="radio" value="all" v-model="sectionPeriod" />
              All
            </div>
            <div
              class="option-radio"
              v-for="option in periods"
              :key="option.value"
            >
              <input
                type="radio"
                :value="option.value"
                v-model="sectionPeriod"
              />
              {{ option.label }}
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="graph-report">-->
      <!--        <div style="grid-area: subtitle">-->
      <!--          <button-->
      <!--            style="float: right"-->
      <!--            class="button"-->
      <!--            @click="careInputExportDataToCSV"-->
      <!--          >-->
      <!--            Download CSV-->
      <!--          </button>-->
      <!--          <p class="subtitle">Social Care Input</p>-->
      <!--        </div>-->
      <!--        &lt;!&ndash; Quarterly or Annually &ndash;&gt;-->
      <!--        <div id="graph-input" class="graphing" ref="graph-input"></div>-->
      <!--        <div class="graph-options-container">-->
      <!--          <div class="graph-options">-->
      <!--            <div class="option-radio">-->
      <!--              <input type="radio" value="all" v-model="inputKeystageKey" />-->
      <!--              All-->
      <!--            </div>-->
      <!--            <div-->
      <!--              class="option-radio"-->
      <!--              v-for="keyStage in keyStages"-->
      <!--              :key="keyStage"-->
      <!--            >-->
      <!--              <input-->
      <!--                type="radio"-->
      <!--                :value="keyStage"-->
      <!--                v-model="inputKeystageKey"-->
      <!--              />-->
      <!--              {{ keyStage }}-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="graph-options">-->
      <!--            <div class="option-radio">-->
      <!--              <input type="radio" value="all" v-model="inputPeriod" />-->
      <!--              All-->
      <!--            </div>-->
      <!--            <div-->
      <!--              class="option-radio"-->
      <!--              v-for="option in periods"-->
      <!--              :key="option.value"-->
      <!--            >-->
      <!--              <input type="radio" :value="option.value" v-model="inputPeriod" />-->
      <!--              {{ option.label }}-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
/* global Plotly */
import { mapGetters, mapActions } from 'vuex'
import jsonexport from 'jsonexport'
import subQuarters from 'date-fns/subQuarters'
import startOfQuarter from 'date-fns/startOfQuarter'
import endOfYear from 'date-fns/endOfYear'
import startOfYear from 'date-fns/startOfYear'
import endOfQuarter from 'date-fns/endOfQuarter'
import subYears from 'date-fns/esm/subYears/index.js'
import getQuarter from 'date-fns/getQuarter/index.js'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'

const isDateBetweenCurry = period => date => {
  if (!date || !period || !period.length === 2) return true
  if (isAfter(date, period[0]) && isBefore(date, period[1])) return true
  return false
}

const graphFont = {
  family: 'ArboriaBook',
  size: '16',
  color: '#151B2F'
}

const colourLookup = {
  Outstanding: '#00B9C1',
  Good: '#49E5A6',
  'Requires Improvement': '#FFCB4B',
  Inadequate: '#E76D93',
  'Not Applicable': '#D4D6E4'
}

const labelDescription = {
  outstanding: {
    label: 'Outstanding',
    colour: '#00B9C1',
    order: 0
  },
  good: {
    label: 'Good',
    colour: '#49E5A6',
    order: 1
  },
  requires_improvement: {
    label: 'Requires Improvement',
    colour: '#FFCB4B',
    order: 2
  },
  inadequate: {
    label: 'Inadequate',
    colour: '#E76D93',
    order: 3
  },
  not_applicable: {
    label: 'Not Applicable',
    colour: '#D4D6E4',
    order: 4
  }
}

const labelOrder = [
  'Outstanding',
  'Good',
  'Requires Improvement',
  'Inadequate',
  'Not Applicable'
]

export default {
  name: 'CustomReports',
  data() {
    return {
      needsKey: 'all',
      sectionKey: 'a',
      keystageKey: 'all',
      sectionKeystageKey: 'all',
      // inputPeriodKey: 'all',
      // inputKeystageKey: 'all',
      panPeriod: 'all',
      sectionPeriod: 'all',
      // inputPeriod: 'all',
      layout: {
        legend: {
          traceorder: 'normal',
          font: {
            family: 'ArboriaBook',
            size: '16'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      assignments: 'assignment/assignments',
      audits: 'assignment/audits'
    }),
    completedAudits() {
      return this.audits.filter(a => a.completedAt && !a.assignmentId.archived)
    },
    assignmentData() {
      return this.assignments.filter(a => a.completedAt)
    },
    needs() {
      return new Set(this.completedAudits.map(a => a.planId.need))
    },
    keyStages() {
      return new Set(this.completedAudits.map(a => a.planId.stage))
    },
    primaryNeedData() {
      if (!this.needsKey || !this.keystageKey) {
        return {}
      }
      let audits = this.completedAudits
        .filter(a =>
          this.needsKey === 'all' ? true : a.planId.need === this.needsKey
        )
        .filter(a =>
          this.keystageKey === 'all'
            ? true
            : a.planId.stage === this.keystageKey
        )
      if (this.panPeriod !== 'all') {
        const dates = JSON.parse(this.panPeriod).map(v => new Date(v))
        const isDateBetween = isDateBetweenCurry(dates)
        audits = audits.filter(({ completedAt }) =>
          isDateBetween(new Date(completedAt))
        )
      }
      const outcomes = audits
        .filter(a => a.outcome && !!labelDescription[a.outcome])
        .map(a => a.outcome)
      const keys = new Set(outcomes)
      const values = Array.from(keys)
        .flatMap(k => {
          return {
            key: labelDescription[k] ? labelDescription[k].label : '',
            data: outcomes.filter(o => o === k).length
          }
        })
        .reduce((accumulated, item) => {
          return {
            ...accumulated,
            [item.key]: item.data
          }
        }, {})

      const ordered = {}
      Object.keys(values)
        .sort((a, b) => labelOrder.indexOf(a) - labelOrder.indexOf(b))
        .forEach(k => (ordered[k] = values[k]))
      return ordered
    },
    primaryExportData() {
      if (!this.needsKey || !this.keystageKey) {
        return []
      }
      return this.completedAudits
        .filter(a => !!labelDescription[a.outcome])
        .filter(a =>
          this.needsKey === 'all' ? true : a.planId.need === this.needsKey
        )
        .filter(a =>
          this.keystageKey === 'all'
            ? true
            : a.planId.stage === this.keystageKey
        )
        .map(a => {
          return {
            ...a.planId,
            AuditorName: a.auditor.name,
            Started: a.assignmentId.startedAt,
            Completed: a.assignmentId.completedAt,
            Outcome: a.outcome ? labelDescription[a.outcome].label : ''
          }
        })
    },
    primaryNeedTrace() {
      return [
        {
          values: Object.values(this.primaryNeedData),
          labels: Object.keys(this.primaryNeedData),
          type: 'pie',
          sort: false,
          hole: 0.6,
          textfont: graphFont,
          hoverlabel: {
            font: graphFont
          },
          marker: {
            colors: Object.keys(this.primaryNeedData).map(k => colourLookup[k]),
            line: {
              width: 10,
              color: '#FFF'
            }
          }
        }
      ]
    },
    auditSectionData() {
      let audits = this.completedAudits
        .filter(a =>
          this.sectionKeystageKey === 'all'
            ? true
            : a.planId.stage === this.sectionKeystageKey
        )
        .map(audit => {
          return {
            ...audit,
            sections: audit.sections.filter(
              section => section.id === this.sectionKey
            )
          }
        })
      if (this.sectionPeriod !== 'all') {
        const dates = JSON.parse(this.sectionPeriod).map(v => new Date(v))
        const isDateBetween = isDateBetweenCurry(dates)
        audits = audits.filter(({ completedAt }) =>
          isDateBetween(new Date(completedAt))
        )
      }
      const outcomes = audits
        .filter(a => a.outcome && a.sections.length)
        .map(a => {
          const sectionId = a.sections.findIndex(
            section => section.id === this.sectionKey
          )
          if (['i', 'j', 'k'].includes(this.sectionKey)) {
            switch (a.sections[sectionId].determination) {
              case 'outstanding':
                return 'good'
              case 'inadequate':
                return 'requires_improvement'
              default:
                return a.sections[sectionId].determination
            }
          } else {
            return a.sections[sectionId].determination
          }
        })
      const keys = new Set(outcomes)
      const values = Array.from(keys)
        .flatMap(k => {
          return {
            key: labelDescription[k] && labelDescription[k].label,
            data: outcomes.filter(o => o === k).length
          }
        })
        .filter(i => !!i.key)
        .reduce((accumulated, item) => {
          return {
            ...accumulated,
            [item.key]: item.data
          }
        }, {})
      const ordered = {}
      Object.keys(values)
        .sort((a, b) => labelOrder.indexOf(a) - labelOrder.indexOf(b))
        .forEach(k => (ordered[k] = values[k]))
      return ordered
    },
    auditSectionDataToExport() {
      return this.completedAudits
        .filter(a =>
          this.sectionKeystageKey === 'all'
            ? true
            : a.planId.stage === this.sectionKeystageKey
        )
        .map(a => {
          return {
            ...a.planId,
            AuditorName: a.auditor.name,
            Started: a.assignmentId.startedAt,
            Completed: a.assignmentId.completedAt,
            Outcome: a.outcome ? labelDescription[a.outcome].label : ''
          }
        })
    },
    auditSectionTrace() {
      return [
        {
          x: Object.keys(this.auditSectionData),
          y: Object.values(this.auditSectionData),
          labels: Object.keys(this.auditSectionData),
          type: 'bar',
          sort: false,
          textfont: graphFont,
          hoverlabel: {
            bordercolor: Object.keys(this.auditSectionData).map(
              k => colourLookup[k]
            ),
            font: graphFont
          },
          marker: {
            color: Object.keys(this.auditSectionData).map(k => colourLookup[k])
          }
        }
      ]
    },
    // careInputData() {
    //   let audits = this.completedAudits
    //     .filter(a =>
    //       this.inputKeystageKey === 'all'
    //         ? true
    //         : a.planId.stage === this.inputKeystageKey
    //     )
    //     .filter(a => a.outcome)
    //
    //   if (this.inputPeriod !== 'all') {
    //     const dates = JSON.parse(this.inputPeriod).map(v => new Date(v))
    //     const isDateBetween = isDateBetweenCurry(dates)
    //     audits = audits.filter(({ completedAt }) =>
    //       isDateBetween(new Date(completedAt))
    //     )
    //   }
    //
    //   const results = audits
    //     .filter(a => !!labelDescription[a.outcome])
    //     .map(a => {
    //       return {
    //         input: a.planId.input,
    //         outcome: labelDescription[a.outcome].label
    //       }
    //     })
    //
    //   const inputs = Array.from(new Set(results.map(i => i.input)))
    //   const outcomes = Array.from(new Set(results.map(i => i.outcome)))
    //   const traces = []
    //   outcomes.forEach(outcome => {
    //     const outcomeObject = {
    //       x: [],
    //       y: [],
    //       name: outcome,
    //       type: 'bar',
    //       sort: false,
    //       textfont: graphFont,
    //       hoverlabel: {
    //         bordercolor: colourLookup[outcome],
    //         font: graphFont
    //       },
    //       marker: {
    //         color: colourLookup[outcome]
    //       }
    //     }
    //     inputs.forEach(input => {
    //       outcomeObject.x.push(input)
    //       outcomeObject.y.push(
    //         results.filter(r => r.input === input && r.outcome === outcome)
    //           .length
    //       )
    //     })
    //     traces.push(outcomeObject)
    //   })
    //   return traces
    //     .sort((a, b) => labelOrder.indexOf(a.name) - labelOrder.indexOf(b.name))
    //     .reverse()
    // },
    // careInputExportData() {
    //   return this.completedAudits
    //
    //     .filter(a =>
    //       this.inputKeystageKey === 'all'
    //         ? true
    //         : a.planId.stage === this.inputKeystageKey
    //     )
    //     .filter(a => a.outcome && labelDescription[a.outcome])
    //     .map(a => {
    //       return {
    //         ...a.planId,
    //         AuditorName: a.auditor.name,
    //         Started: a.assignmentId.startedAt,
    //         Completed: a.assignmentId.completedAt,
    //         Outcome: a.outcome ? labelDescription[a.outcome].label : ''
    //       }
    //     })
    // },
    // careInputTrace() {
    //   return this.careInputData
    // },
    periods() {
      const periods = []

      const now = new Date()
      const lastYear = subYears(now, 1)
      periods.push({
        start: startOfYear(lastYear),
        end: endOfYear(lastYear),
        label: lastYear.getFullYear()
      })
      function getLastQuarter(date) {
        const dayInLastQtr = subQuarters(date, 1)
        return {
          start: startOfQuarter(dayInLastQtr),
          end: endOfQuarter(dayInLastQtr),
          label: `${dayInLastQtr.getFullYear()} Q${getQuarter(dayInLastQtr)}`
        }
      }
      var qtrDay = new Date()
      while (periods.length < 6) {
        var lastQtr = getLastQuarter(qtrDay)
        qtrDay = lastQtr.start
        periods.push(lastQtr)
      }
      return periods.map(({ start, end, label }) => ({
        value: JSON.stringify([start.toString(), end.toString()]),
        label
      }))
    }
  },
  methods: {
    ...mapActions({ fetchAssignments: 'assignment/fetchAllAssignments' }),
    loadGraphs() {
      const primaryAreaOfNeedGraph = this.$refs['graph-need']
      Plotly.newPlot(
        primaryAreaOfNeedGraph,
        this.primaryNeedTrace,
        {},
        {
          displaylogo: false,
          responsive: true,
          autosizable: true
        }
      )
      const sectionGraph = this.$refs['graph-section']
      Plotly.newPlot(
        sectionGraph,
        this.auditSectionTrace,
        { xaxis: { autorange: true } },
        {
          displaylogo: false,
          responsive: true,
          autosizable: true
        }
      )
      // const careInputGraph = this.$refs['graph-input']
      // Plotly.newPlot(
      //   careInputGraph,
      //   this.careInputTrace,
      //   { barmode: 'stack' },
      //   { responsive: true, autosizable: true }
      // )
    },
    refreshGraphs() {},
    resetGraphs() {},
    async exportToCSV() {
      const data = this.primaryExportData.map(
        ({ __v, organisationId, _id, ...rest }) => rest
      )
      const doc = await jsonexport(data)
      const newBlob = new Blob([doc])
      const blobUrl = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', 'report.csv')
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(doc)
    },
    async SectionDataToExportToCSV() {
      const data = this.auditSectionDataToExport.map(
        ({ __v, organisationId, _id, ...rest }) => rest
      )
      const doc = await jsonexport(data)
      const newBlob = new Blob([doc])
      const blobUrl = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', 'report.csv')
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(doc)
    }
    // async careInputExportDataToCSV() {
    //   const data = this.careInputExportData.map(
    //     ({ __v, organisationId, _id, ...rest }) => rest
    //   )
    //   const doc = await jsonexport(data)
    //   const newBlob = new Blob([doc])
    //   const blobUrl = window.URL.createObjectURL(newBlob)
    //   const link = document.createElement('a')
    //   link.href = blobUrl
    //   link.setAttribute('download', 'report.csv')
    //   document.body.appendChild(link)
    //   link.click()
    //   link.parentNode.removeChild(link)
    //   window.URL.revokeObjectURL(doc)
    // }
  },
  watch: {
    needsKey(newVal) {
      Plotly.animate(
        this.$refs['graph-need'],
        {
          data: this.primaryNeedTrace,
          layout: {},
          config: { responsive: true, autosizable: true }
        },
        {
          transition: {
            duration: 500,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 500
          }
        }
      )
    },
    keystageKey(newVal) {
      Plotly.animate(
        this.$refs['graph-need'],
        {
          data: this.primaryNeedTrace,
          layout: {},
          config: { responsive: true, autosizable: true }
        },
        {
          transition: {
            duration: 500,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 500
          }
        }
      )
    },
    sectionKey(newVal) {
      Plotly.animate(
        this.$refs['graph-section'],
        {
          data: this.auditSectionTrace,
          layout: {
            type: 'category',
            xaxis: { autorange: true }
          },
          config: {
            responsive: true,
            autosizable: true
          }
        },
        {
          transition: {
            duration: 300,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 300
          }
        }
      )
      setTimeout(() => {
        Plotly.relayout(this.$refs['graph-section'], {
          'xaxis.autorange': true,
          'yaxis.autorange': true
        })
      }, 300)
    },
    sectionKeystageKey(newVal) {
      Plotly.animate(
        this.$refs['graph-section'],
        {
          data: this.auditSectionTrace,
          layout: {
            xaxis: {
              range: Object.keys(this.auditSectionData).map((a, idx) => idx)
            }
          },
          config: { responsive: true, autosizable: true }
        },
        {
          transition: {
            duration: 300,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 300
          }
        }
      )
      setTimeout(() => {
        Plotly.relayout(this.$refs['graph-section'], {
          'xaxis.autorange': true,
          'yaxis.autorange': true
        })
      }, 300)
    },
    panPeriod(newVal) {
      Plotly.animate(
        this.$refs['graph-need'],
        {
          data: this.primaryNeedTrace,
          layout: {},
          config: { responsive: true, autosizable: true }
        },
        {
          transition: {
            duration: 500,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 500
          }
        }
      )
    },
    sectionPeriod(newVal) {
      Plotly.animate(
        this.$refs['graph-section'],
        {
          data: this.auditSectionTrace,
          layout: {
            xaxis: {
              range: Object.keys(this.auditSectionData).map((a, idx) => idx)
            }
          },
          config: { responsive: true, autosizable: true }
        },
        {
          transition: {
            duration: 300,
            easing: 'cubic-in-out'
          },
          frame: {
            duration: 300
          }
        }
      )
    }
  },
  async mounted() {
    if (!this.audits.length) {
      await this.fetchAssignments()
    }
    this.loadGraphs()
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/components.scss';
@import '@/style/sections.scss';
@import '@/style/modal.scss';

.field {
  display: flex;
  flex-flow: column;
  margin-bottom: 1rem;
  label {
    font-weight: 600;
    font-size: 0.9rem;
    padding-bottom: 0.5rem;
  }
}

span.icon {
  bottom: 0rem;
}

.graph-container {
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  row-gap: 4rem;
}

.graph-report {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: 46px 46px calc(100% - 46px - 46px);
  grid-template-columns: 3fr 1fr 1fr;
  grid-template-areas:
    'subtitle subtitle subtitle'
    'select options options'
    'graph options options';
  .subtitle {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #484846;
  }
}

.graphing {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  grid-area: graph;
}

.graph-options-container {
  grid-area: options;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  align-items: flex-start;
  justify-content: center;
}

.graph-options {
  grid-area: unset;
}

.options-select {
  grid-area: select;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    padding-right: 1rem;
  }
}

.select select {
  display: inline-flex;
  outline: 0;
  appearance: none;
  height: 2.5rem;
  background-color: #fff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  max-width: 100%;
  min-width: 150px;
  width: auto;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  padding: 0.25rem 1rem;
  line-height: 1.5;
}

.select select:focus {
  min-width: 150px;
  width: auto;
}
</style>
